var exports = {
  "container": "x9245d464--046ca8--container",
  "container--hidden": "x9245d464--046ca8--container--hidden",
  "container--info": "x9245d464--046ca8--container--info",
  "container--error": "x9245d464--046ca8--container--error",
  "text": "x9245d464--046ca8--text",
};

module.exports = exports;
